import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppService } from 'src/app/core/services/app.service';
import { FocuslinkService } from 'src/app/core/services/focuslink.service';
import { MenuService } from 'src/app/core/services/menu.service';
import { UserService } from 'src/app/core/services/user.service';
import { CommandCenterConfiguration } from 'src/app/shared/models/CommandCenterConfiguration';
import { AppMessageSeverity } from 'src/app/shared/models/enums/AppMessageSeverity.enum';
import { User } from 'src/app/shared/models/user.model';

@Component({
	selector: 'app-user-menu-setup',
	templateUrl: './user-menu-setup.component.html',
	styleUrls: ['../../../commandcenter.scss'],
})
export class UserMenuSetupComponent implements OnInit {
	@Input() changesToSave: boolean;
	@Output() changesToSaveChange = new EventEmitter<boolean>();

	@Input() user: User;
	@Output() userChange = new EventEmitter<User>();

	menuOptions: menuModel[];
	userHiddenMenus: menuModel[];

	constructor(public app: AppService, public userService: UserService, private focuslink: FocuslinkService, public menuService: MenuService) {}

	ngOnInit(): void {
		this.buildMenu().then((data) => (this.menuOptions = data));
	}

	async buildMenu(): Promise<any> {
		const resp = await this.focuslink.adminCommandCenterConfigurationGet(this.userService.userSubscription.value.preferences.menuVersion);

		const menuReturn = new CommandCenterConfiguration(resp);
		let preMenu = menuReturn.menu;
		preMenu = preMenu.filter((menu) => this.userService.user.role >= menu.itemUserLevel);

		const menu: menuModel[] = preMenu.filter((i) => !i.parentKey);
		menu.forEach((p) => {
			const idx = preMenu.findIndex((i) => i.key === p.key);
			preMenu.splice(idx, 1);
			p.separator = true;
			p.items = [];
		});
		preMenu.forEach((m) => {
			let existParentIdx = menu.findIndex((i) => i.key === m.parentKey);
			if (existParentIdx !== -1) {
				menu[existParentIdx].items.push(m);
			} else {
				let found: boolean = false;
				for (let parent of menu) {
					for (let subParent of parent.items) {
						if (subParent.key === m.parentKey) {
							subParent.items ? subParent.items.push(m) : (subParent.items = [m]);
							found = true;
							break;
						}
					}
					if (found) break;
				}
				if (!found) {
					const parent: menuModel = preMenu.find((i) => i.key === m.parentKey);
					if (parent) {
						parent.items ? parent.items.push(m) : (parent.items = [m]);
					}
				}
			}
		});
		menu.forEach((parent, index) => {
			parent.items?.forEach((subParent) => {
				subParent.items?.sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1));
			});
			parent.items?.sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1));

			if (parent.items?.length === 0) {
				// menu.splice(index, 1);
			}
		});

		return menu;
	}

	async onSave() {
		await this.focuslink.userEdit(this.userService.user);
		this.userService.userSubscription.next(this.userService.user);
		this.menuService.buildMenu(this.menuService.rawMenu);
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: '', detail: `Your profile has been updated.` });
		this.changesToSaveChange.emit(false);
	}

	selectMenuToHide() {
		this.userChange.emit(this.user);
	}
}

interface menuModel {
	key?: string;
	parentKey?: string;
	separator?: boolean;
	label?: string;
	faIcon?: string;
	faIconPrefix?: string;
	icon?: string;
	sortOrder?: number;
	itemUserLevel?: number;
	description?: string;

	routerLink?: string[];
	items?: menuModel[];
}
